<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div class="warn-dialog">
  <div class="title">
    <p>Selecionar grupo de Empresa</p>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onCancel()"
      >close</mat-icon
    >
  </div>

  <hr />

  <div class="content">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar por nome</mat-label>
      <img matPrefix src="../../../../../assets/svg/icons/search.svg" alt="Lupa" class="search-icon" />
      <input
        matInput
        type="text"
        placeholder=" "
        (input)="updateFieldText($event)"
      />
    </mat-form-field>

    <div *ngFor="let grupo of listaDeGrupos" class="grupo-checkbox">
      <div class="container-nome">
        <mat-checkbox
          [checked]="getCheckboxState(grupo).checked"
          [indeterminate]="getCheckboxState(grupo).indeterminate"
          (change)="toggleGrupo(grupo, $event.checked)">
        </mat-checkbox>
        <p class="nome">{{grupo.nome}}</p>
      </div>

      <hr />

      <div class="container-usuarios container-checkbox-cinza">
        <p class="selecao-destinatarios">Destinatário:</p>
        <mat-checkbox
          [(ngModel)]="grupo.buscaPessoas"
          (change)="onToggleFilho(grupo)">
        </mat-checkbox>
        <p class="tag-select">Pessoas do grupo</p>

        <mat-checkbox
          [(ngModel)]="grupo.buscaUsuarios"
          (change)="onToggleFilho(grupo)">
        </mat-checkbox>
        <p class="tag-select">Usuários do grupo</p>
      </div>
    </div>
  </div>

  <hr />

  <div class="modal-footer" mat-dialog-actions>
    <button matButton="filled" (click)="onConfirm()">Confirmar e selecionar</button>
  </div>
</div>
